import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';
import * as websocketTypes from '~/redux/middleware/socket/constants';
import Bugsnag from '@bugsnag/js'
import {Config} from '~/config';
import {Layout} from '@components/layout';
import OneSignal, { useOneSignalSetup } from 'react-onesignal';

function* configureBugSnagUser({user}) {
    if (Config.params.BUGSNAG) {
        Bugsnag.setUser(user.id, user.email, user.name)
    }
}
function* configureOneSignalUser({user}) {
    if (Config.params.ONESIGNAL) {
        const interval = setInterval(async () => {
            if (OneSignal.getOneSignalInstance()) {
                clearInterval(interval);
                OneSignal.setExternalUserId(user.id);
            }
        }, 200);
    }
}
function* initWebsocket({user}) {
    yield put({
        type: websocketTypes.SOCKET_MANAGEMENT_INIT_CONNECT,
        user,
    })
}

function* rootSagas() {
    yield takeEvery([
        types.USER_CONTEXT_SUCCESS,
        types.LOGIN_ATTEMPT_SUCCESS,
    ], configureBugSnagUser);
    yield takeEvery([
        types.USER_CONTEXT_SUCCESS,
        types.LOGIN_ATTEMPT_SUCCESS,
    ], configureOneSignalUser);
    yield takeEvery([
        types.USER_CONTEXT_SUCCESS,
        types.LOGIN_ATTEMPT_SUCCESS,
        types.USER_REGISTRATION_SUCCESS
    ], initWebsocket);
    yield takeEvery([
        types.LOGIN_ATTEMPT_REQUEST
    ], (Layout.actions.openPreloaderSaga));
    yield takeEvery([
        types.LOGIN_ATTEMPT_SUCCESS,
        types.LOGIN_ATTEMPT_FAILURE,
    ], (Layout.actions.closePreloaderSaga));
    yield takeEvery([
        types.USER_REGISTRATION_REQUEST
    ], (Layout.actions.openPreloaderSaga));
    yield takeEvery([
        types.USER_REGISTRATION_SUCCESS,
        types.USER_REGISTRATION_FAILURE,
    ], (Layout.actions.closePreloaderSaga));
}

export default rootSagas;
